module.exports = __webpack_public_path__ + "static/Sabine_Condiescu-2c1fbfb1d79ed0ee6c35d150be0283fd.png";